import React, {
  memo, useEffect, useRef, useState,
} from 'react';
import { createUseStyles } from 'react-jss';

import Image from 'app/lib/Image';
import Spinner from 'app/components/common/spinner/Spinner';

import stampLogo from 'assets/image/stamp-2-logo.png';
import stampBorder from 'assets/image/stamp-2-border.png';

interface StampProps {
  stampContainerRef?: React.MutableRefObject<null>,
  logoContainerRef?: React.MutableRefObject<null>,
  loaderColor?: string,
  logo?: string,
}

const Stamp: React.FC<StampProps> = (props) => {
  const {
    stampContainerRef,
    logoContainerRef,
    loaderColor = '#333',
    logo,
  } = props;

  const classes = useStyles();

  const isLoading = logo === 'loading';

  const LocalLogoContainerRef = useRef<any>();

  const [isImageLoading, setImageLoading] = useState(false);

  const src = logo || stampLogo;

  useEffect(() => {
    if (logoContainerRef || stampContainerRef) {
      return undefined;
    }

    const img = new Image(src, src).load();
    setImageLoading(true);
    const current = (LocalLogoContainerRef.current as any);
    const element = img.getElement();
    const removeHandleLoad = img.addEventListener(Image.EVENT.LOAD, () => {
      element.classList.add('logo');
      current?.appendChild(element);
      setImageLoading(false);
    });

    return () => {
      if (element.parentElement) {
        element.remove();
      } else {
        removeHandleLoad();
      }
    };
  }, [src, logoContainerRef, stampContainerRef]);

  if (!logoContainerRef && stampContainerRef) {
    return (<div className={classes.stamp} ref={stampContainerRef} />);
  }

  return (
    <div className={classes.stamp}>
      <div className="logo" ref={logoContainerRef || LocalLogoContainerRef} />
      {!logoContainerRef && (isLoading || isImageLoading) && (
        <Spinner
          color={loaderColor}
          size={40}
          style={{ position: 'absolute', right: '1.5rem', top: '1.5rem' }}
        />
      )}
      <img
        src={stampBorder}
        className="border"
        alt="border"
        style={{ width: '100%', height: 'auto' }}
      />
    </div>
  );
};

const useStyles = createUseStyles({
  stamp: {
    '&': {
      position: 'absolute',
      visibility: 'visible',
      margin: '3.3em 3.6em 0 auto',
      width: '34%',
      right: 0,
      top: 0,
    },
    '& > img': {
      maxWidth: '100%',
    },
    '& > img.border': {
      position: 'absolute',
    },
    '& > .logo': {
      position: 'absolute',
      maxWidth: '44.8%',
      marginTop: '9.2%',
      marginLeft: '45%',
    },
    '& > img.loader': {
      position: 'absolute',
      maxWidth: '12%',
      marginTop: '23.2%',
      marginLeft: '61%',
    },
  },
});

export default memo(Stamp);
